import { CollapsibleRadio } from './collapsible-radio';
import { renderAndMountComponent } from '@wix/answers-lib';
import { RadioGroup } from '../../primitives/radio-group/radio-group';
import * as React from 'react';
// tslint:disable-next-line:max-line-length
import { createRadioGroupLegacyDriver } from '../../primitives/radio-group/radio-group.legacy-driver';
export var createCollapsibleRadioGroupDriver = function (wrapper) {
    return createRadioGroupLegacyDriver(wrapper);
};
export var createCollapsibleRadioGroupComp = function (props) {
    var radioButtonComp = props.items.map(function (item) {
        var title = "title is " + item;
        var desc = "description - " + item;
        var isDisabled = props.disabledValues.indexOf(item) > -1;
        return (React.createElement(CollapsibleRadio, { title: title, description: desc, value: item, key: item, disabled: isDisabled }, item));
    });
    var radioGroup = (React.createElement(RadioGroup, { onChange: props.onChange, selectedValue: props.items[0] }, radioButtonComp));
    var element = renderAndMountComponent(radioGroup);
    return createCollapsibleRadioGroupDriver(element);
};
//# sourceMappingURL=collapsible-radio.driver.js.map